import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Button,
  Divider,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const TermsCompanyPage: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/chat');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        py: { xs: 2, sm: 4, md: 6 },
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={handleBack}
            sx={{
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            戻る
          </Button>
        </Box>

        <Paper
          elevation={8}
          sx={{
            p: { xs: 3, sm: 4, md: 6 },
            borderRadius: 3,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(20px)',
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 'bold',
              textAlign: 'center',
              mb: 4,
              background: 'linear-gradient(45deg, #667eea, #764ba2)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              color: 'transparent',
            }}
          >
            企業向け利用規約
          </Typography>

          <Box sx={{ mb: 4, textAlign: 'center' }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              会社名：株式会社Gerbera
            </Typography>
            <Typography variant="body1" color="text.secondary">
              代表取締役：𠮷岡 歩真
            </Typography>
          </Box>

          <Divider sx={{ mb: 4 }} />

          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
            株式会社Gerbera（以下「弊社」といいます）は、当社が運営するサービス「ガクフドキャリア」（以下「本サービス」といいます）の利用に際し、以下の利用規約（以下「本規約」といいます）を定めます。
          </Typography>

          <List sx={{ mb: 4 }}>
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第1条（目的）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
                      1　この利用規約（以下「本規約」という）は、株式会社Gerbera（以下「弊社」という）が提供するサービス「ガクフドキャリア」（以下「本サービス」という）を利用する際に適用する条件を定めるものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
                      2　本サービス申し込み者（以下「申込者」という）は、本規約及びそれに付随する特約を遵守するものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      3　本サービスに関して、個別申込書において本規約と異なる定めをしたときは、個別申込書の定めが優先するものとする。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第2条（定義）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
                      本規約における用語の定義は、以下のとおりとする。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      （１）「本契約」とは、弊社が申込者に対して本サービスを提供する旨の、本規約が契約内容を構成する当該2者間の契約をいい、第3条に従って申込者が弊社に本サービスの利用申込みを行い、弊社がこれを承諾したときに成立するものをいう。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      （２）「人材紹介」とは、弊社が申込者及び求職者の申込みを受け、申込者と求職者との間における雇用関係の成立を斡旋することをいう。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      （３）「候補者」とは、本サービスを利用する求職者をいう。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      （４）「新規採用者」とは、申込者が採用することを決定し、入社合意に至った候補者をいう。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      （５）「入社合意」とは、本サービスを通じて選考を受けた候補者が、選考に合格し、申込者からの入社意思の確認に対し、承諾の意思表示を行うことをいう。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      （６）「ポリシー等」とは、本サービスに関して、本規約とは別に「方針」、「ポリシー」、「ポリシー等」などの名称で弊社が掲示している文書をいう。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第３条（申込み）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
                      １　申込者は、本規約の全ての内容を遵守することに同意し、本サービスの申込みを行うものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ２　申込者は弊社に対し、本サービスの申込みに当たり、申込者に関する真実かつ正確な情報を届け出なければならない。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第４条（本サービスの内容）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
                      １　申込者は、候補者から任意の者を選び、申込者の判断に基づき選考のうえ、その採用の可否を判断する。ただし、申込者は、当該候補者が選考を辞退する可能性や、候補者が他企業の求人に対して応募する可能性があることをあらかじめ承諾する。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ２　弊社は、職業紹介事業者として通常課される責任において、本サービスを誠実に遂行する。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第５条（候補者への求人条件等の開示・公開）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      １　申込者は弊社に対し、職業安定法（以下「職安法」という）第５条の３第２項に従い、書面、電子メールその他同法所定の方法（以下「書面交付等の方法」という）により、同項の定める労働条件その他希望する求人の条件（以下これらを「求人条件」という。）を明示する。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ２　申込者は前項の明示に際して、虚偽又は誇大な条件、法令に違反する条件を明示してはならない。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ３　弊社は、申込者から提供された求人情報に基づいて求人票を作成し、申込者の確認を経て開示・公開する。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ４　申込者は、弊社から当該求人票の確認を求められたときは、速やかに内容を確認し、変更等の必要がある場合は、弊社にその旨を通知するものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ５　申込者は、本条第３項の求人票の開示・公開後、本条第1項により明示した求人条件の内容に変更、特定、削除、追加が生じた場合は、書面交付等の方法によりその旨を速やかに弊社に通知するものとする。また、当該求人票の内容や募集状況について、弊社から確認を求められたときは、速やかに回答し、変更がある場合は最新の情報を提供するものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ６　申込者が、事前に希望しない旨を指定した場合を除き、弊社は、求人票に記載の求人条件、申込者から提供された情報及び一般に公開されている申込者の企業情報等の弊社が独自に収集した情報等（以下「求人条件等」という）を、候補者に対して開示・提供できるものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ７　申込者が、事前に希望しない旨を指定した場合を除き、弊社は、弊社が候補者を募集する目的で、求人条件等を、弊社のウェブサイト等において開示・公開できるものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ８　弊社は、前7項にかかわらず、職安法第5条の6に規定されている求人を受理しないことができる事由に該当した場合には、申込者の求人を受理しないことができるものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ９　申込者は、職安法第5条の6に規定されている求人を受理しないことができる事由に該当しないことを表明するものとし、後にこれに該当する事由が発生した場合は速やかに弊社へ通知するものとする。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第6条（申込者の通知・協力義務）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      １　申込者は、候補者に関して自ら選考のうえ、採用するか否かを決定したときは、速やかに候補者及び弊社に対してその旨を通知しなければならない。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ２　申込者は、前項において採用の通知をする場合、候補者に対して所定の内定通知書（労働基準法第１５条に基づく労働条件を明示したもの）又はこれと同等の事項を記載した文書を交付しなければならない。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ３　前項により明示した求人条件の内容に変更等が生じた場合、申込者は職安法第５条の３第３項に従い、変更等の内容を書面交付等の方法により、弊社に通知した上で、自らの責任において速やかに候補者に明示しなければならない。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ４　申込者は、弊社が候補者を紹介した後に、当該候補者について他の手段により応募があった場合には、弊社の紹介による応募を優先して取り扱わなければならない。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ５　申込者は、候補者が在籍している学校、企業又は在籍していた学校、企業に当該候補者の採用選考に係る目的で連絡をしてはならない。ただし、申込者が候補者から承諾を得た場合は、この限りでない。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ６　申込者は、新規採用者の内定を取り消す場合、弊社に通知のうえ、すべて自己の責任において新規採用者との間に発生する紛争を処理する。ただし、内定取消が弊社の責に帰すべき事由による場合は、この限りではない。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ７　申込者は、新規採用者を期間の定めのない雇用形態において雇用する社員として採用した場合において、当該新規採用者が入社後6ヵ月以内に退職（解雇による退職を除く）したときには、当該事実を速やかに弊社に報告しなければならない。また、申込者は、弊社から当該事実の有無について確認を受けた場合、これに協力するものとする。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第７条（報酬額と支払方法）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      １　申込者が候補者の採用を決定し、当該候補者と入社合意に至った場合、申込者は弊社に対して、本サービスの報酬を支払うものとし、その金額は申込者と弊社が予め合意した通りとする。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ２　前項の規定は、申込者が弊社の紹介する候補者の不採用を決定した日から1年以内に、申込者が当該候補者を採用した場合、又は申込者の斡旋により申込者の関係会社が当該候補者を採用した場合にも適用される。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ３　申込者が、故意又は重大な過失により、弊社に当該候補者の採用を通知しなかった場合は、弊社は、申込者に対し、本条第1項の報酬に加え当該報酬と同額の違約金を請求することができる。また、本違約金の請求は弊社の損害賠償請求権の行使を妨げないものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ４　弊社は申込者に対して、第1項の報酬額及びこれに係る消費税を新規採用者の入社合意月の翌月3営業日までに請求し、申込者はこれを新規採用者が入社合意した月の翌月末日までに弊社指定の銀行口座に振込みにより支払う。なお、振込手数料は申込者の負担とする。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ５　申込者は、前項にかかわらず自らと異なる請求先を別途指定することができる。ただし、申込者は弊社に対し、当該請求先から報酬の支払いがなされない場合には、直ちに報酬を支払うものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ６　申込者が報酬の支払を遅滞した場合、弊社に対し、所定の支払期日の翌日から完済日までの日数に、年１４．６％（１年を３６５日とする日割計算）の利率で計算した金額を遅延損害金として報酬額に付加して支払うものとする。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第８条（報酬の返還）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ mt: 1, lineHeight: 1.7 }}>
                    弊社は、前条の報酬について、第１１条（内定取消等の対応）に定める場合以外での返金はしないものとする。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第９条（同意事項）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
                      申込者は弊社に対し、次の各号の事項について同意する。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      （１）本サービスを利用して、申込者が候補者に対して提供した情報及び候補者から提供された情報を、弊社が閲覧すること
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      （２）弊社が電子メール、郵便、電話又はファックス等の手段を用いて連絡すること
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      （３）弊社が、申込者の名称及びロゴを弊社のサービスサイト及び販促用パンフレットへの掲載等のマーケティング業務において使用すること
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      （４）弊社が、申込者の採用傾向等、申込者が本サービスを利用することから判明する情報を、申込者を特定できない形で本サービスの品質向上等のために利用する場合があること
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      （５）弊社が、本サービスの提供に際して、本契約の義務と同様の義務を負わせる等必要な措置を講じた上で、その一部を弊社と契約する第三者に業務委託する場合があること
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      （６）新規採用者が、学校年度の最終月以外で卒業した場合であっても、内定取消とならない限り、本サービスを利用し採用決定した新規採用者として報酬の支払い対象となること
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      （７）新規採用者が、卒業年度を詐称していた又は留年により入社時期が変更になった場合であっても、内定取消とならない限り、本サービスに基づき採用決定した新規採用者として報酬の支払い対象となること
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１０条（接触済の候補者への対応）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      １　申込者は、弊社から申込者に紹介した候補者について、紹介時点で、オンラインオフラインを問わず、面接（Web面接含む）等の採用選考を目的とした接触があった場合、当該候補者の紹介日から３０日以内に弊社に書面交付等の方法により、その旨を報告することができるものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ２　前項の報告内容を弊社が認めた場合、第７条1項に関わらず、入社合意に至った場合でも、報酬は発生しないものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ３　前項にかかわらず、当該候補者の紹介日から30日以内に本条第1項に記載の内容を弊社に報告した場合であっても、弊社が申込者から報告を受けた時点で、既に当該候補者が弊社に対して内定を承諾した旨の報告を行い、これに対する弊社の内定承諾確定処理が完了している場合は、第７条1項に定める報酬は発生するものとする。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１１条（内定取消等の対応）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      １　弊社は、申込者が次の各号のいずれかに該当し、その旨を新規採用者の入社予定日の前日までに書面交付等の方法により弊社へ連絡をした場合に限り、第７条第1項に定める報酬を返金する。なお、返金する報酬には、利息は付さないものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （１）新規採用者から辞退の意思表示を受け、内定を取り消した場合
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （２）新規採用者の責めに帰すべき事由により、内定を取り消した場合
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ２　申込者が、対象となる新規採用者の入社予定日以降に、前項に記載の連絡をした場合は返金の対象外とする。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ３　弊社は、申込者からの第1項の報告受領月の末日を締切として、翌月末日限り、申込者が指定する口座に振り込みによる方法で返金する。なお、振込手数料は弊社の負担とする。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１２条（秘密保持）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      １　本規約において「秘密情報」とは、本契約に関連して、相手方より書面、口頭又は記録媒体等により提供もしくは開示された相手方の技術、営業、業務、財務、組織、その他の事項に関する全ての情報をいう。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ２　秘密情報には、次の各号に定める情報は含まないものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （１）相手方から提供もしくは開示を受けたときに、既に知得していたもの
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （２）相手方から提供もしくは開示を受けた後、自己の責めに帰せざる事由により公知となったもの
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （３）提供又は開示の権限のある第三者から秘密保持義務を負うことなく適法に取得したもの
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （４）秘密情報によることなく単独で開発したもの
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （５）相手方から秘密保持の必要がない旨書面で確認されたもの
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ３　申込者及び弊社は、秘密情報を本契約の履行にのみに利用し、相手方の書面による承諾、又はシステム上の承諾なしに第三者に秘密情報を提供、開示又は漏洩してはならない。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ４　前項の定めにかかわらず、申込者及び弊社は、法律、裁判所又は政府機関の命令等に基づき、秘密情報を開示することができる。ただし、当該命令等があった場合、速やかにその旨を相手方に通知するものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ５　申込者及び弊社は、秘密情報を記載した文書又は磁気記録媒体等を複製する場合には、事前に相手方の書面等による承諾を得ることとし、複製物の管理については第3項に準じて厳重に行うものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ６　申込者及び弊社は、相手方から求められた場合にはいつでも、遅滞なく、相手方の指示に従い、秘密情報並びに秘密情報を記載又は包含した書面その他の記録媒体物及びその全ての複製物を返却又は廃棄するものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ７　申込者は、弊社が申込者の本サービス利用状況等を、統計化して保有、利用又は提供することがあることを承諾する。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１３条（個人情報の取扱）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      １　申込者及び弊社は、申込者が弊社の紹介する候補者を採用するか否かにかかわらず、紹介されるすべての候補者の個人情報が法令により保護される対象であることを確認する。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ２　弊社は、求人条件に何ら関連のない候補者の機微な個人情報（人種、民族、社会的身分、門地、本籍、出生地その他社会的差別の原因となるおそれのある事項、思想及び信条、労働組合への加入状況をいう）について、候補者から収集せず申込者に対して開示又は提供しない。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ３　申込者は、候補者の個人情報を自己の責任による適切な管理のもとに秘密として取り扱い、候補者本人の事前の承諾なくして第三者に提供してはならず、また本サービス以外の目的で使用してはならない。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ４　申込者は、本サービスに必要な範囲を超えて候補者の個人情報を加工又は複製してはならない。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ５　申込者は、候補者の個人情報が漏洩した場合又は漏洩したおそれがある場合（以下当該事態を「事故」という）、直ちにその旨を弊社に報告し、協議のうえ、適切な対応をとらなければならない。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ６　前項の場合、弊社は、申込者に対し、弊社が必要と判断するときは、相当かつ合理的と認める範囲で事故解決に関する指示又は援助を行うことができるものとし、申込者は、当該指示や法令等に従い、事故の拡大又は再発を防止するために必要な措置を講じなければならない。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ７　申込者は、事故発生が弊社の責に帰すべきものである場合を除き、事故解決に要した一切の費用を負担するものとする｡
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ８　申込者は、弊社が申込者から提供された個人情報を、企業名及び個人を特定できない形で、本サービスの提供に必要な範囲、それに関連する事項及びポリシー等で定められた目的の範囲で使用することがあることを承諾する。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１４条（著作物等の取扱い）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ mt: 1, lineHeight: 1.7 }}>
                    本サービスにつき、申込者から弊社に提供した申込者に権利が帰属する著作物及び広告・情報・記事・写真・イラスト・ロゴ等のコンテンツに関しては、申込者は、あらかじめ、本サービスの目的の範囲（候補者の募集を目的とした広告掲載を含む）において及び第９条第２号の同意に基づき、弊社が使用することを許諾するものとする。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１５条（業務委託）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      １　申込者は、本契約に関する申込者の採用業務を弊社以外の採用代行会社又はその他の第三者に委託する場合（以下「委託先」という）、十分な安全管理基準を満たす委託先を選定し、候補者の個人情報についての厳重かつ適正な取扱いを定めた契約を締結し、委託先の当該個人情報の取扱いについて必要かつ適切な監督を行わなければならない。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ２　委託先の責に帰すべき事由により弊社に損害が発生した場合は、申込者は、委託先と連帯して弊社に対して損害を賠償するものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ３　申込者が、弊社に対し、候補者の個人情報を委託先に直接提供することを求める時は、委託先が正当な権限を有する旨を書面交付等の方法により弊社に事前通知するものとする。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１６条（利用者）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ mt: 1, lineHeight: 1.7 }}>
                    申込者は、本規約に基づき本サービスを利用する者（自己の従業員、委託先又はその他の第三者）が、申込者より正当な権限の付与を受けた者であることを保証する。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１７条（免責）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      １　弊社は、申込者に対し、本サービスの利用による採用の確実性、候補者の資質・能力及び応募書類等の情報の正確性等、本サービスの効果並びに候補者に関する保証は行わないものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ２　弊社は、自己の責に帰すべき事由がある場合を除き、申込者と候補者その他の第三者との間のトラブルについては責任を負わないものとする。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１８条（損害賠償）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ mt: 1, lineHeight: 1.7 }}>
                    申込者及び弊社は、本サービスの遂行に際し、自己の責に帰すべき事由により相手方に損害を発生させた場合、法律上負うべき損害を賠償するものとする。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１９条（規約の変更）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      １　弊社は、自己の裁量により本規約を適宜変更できるものとする。ただし、弊社は、本規約について重要な変更を行う場合は、当該変更内容・条件等（以下、「変更条件」といいます）の適用開始日の１４日前までに、電子メール等を通じて申込者に通知する。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ２　申込者は、変更条件を承諾しない場合は、弊社に対し、１４日以内に到達するよう、書面等にて通知しなければならない。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ３　前項の通知があった場合を除き、本規約は、適用開始日から当該変更条件どおりに変更されるものとし、弊社は、本規約変更後に、申込者が、弊社からの新たな候補者の推薦を受諾した時点で、本規約変更に対する承諾の意思表示の有無を問わず、変更後の本規約に同意したものとみなす。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第２０条（法令遵守）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ mt: 1, lineHeight: 1.7 }}>
                    申込者及び弊社は、候補者を採用・雇用し、又は本サービスを遂行するにあたり、関係諸法令（労働基準法、労働契約法、職安法等）の定める求人者又は職業紹介事業者の義務を遵守しなければならない。
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第２１条（反社会的勢力の排除）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      １　申込者及び弊社は、現在、反社会的勢力に該当しないこと、及び次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを確約する。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （１）反社会的勢力が経営を支配していると認められる関係を有すること
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （２）反社会的勢力が経営に実質的に関与していると認められる関係を有すること
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （３）反社会的勢力と取引関係を有すること
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （４）自己、自社もしくは第三者の不正の利益を図る目的又は第三者に損害を加える目的をもってするなど、不当に反社会的勢力を利用していると認められる関係を有すること
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （５）反社会的勢力に対して資金等を提供し、又は便宜を供与するなどの関与をしていると認められる関係を有すること
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （６）役員又は経営に実質的に関与している者が反社会的勢力と社会的に非難されるべき関係を有すること
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ２　申込者及び弊社は、自ら又は第三者を利用して次の各号のいずれかに該当する行為を行わないことを確約する。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （１）暴力的な要求行為
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （２）法的な責任を超えた不当な要求行為
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （３）取引に関して、脅迫的な言動をし、又は暴力を用いる行為
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （４）風説を流布し、偽計を用い又は威力を用いて相手方の信用を毀損し、又は相手方の業務を妨害する行為
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （５）反社会的勢力に自己の名義を利用させ、本サービスに関する契約及び本規約に基づく契約を締結する行為
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （６）その他前各号に準ずる行為
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ３　申込者又は弊社は、相手方が反社会的勢力もしくは第１項各号のいずれかに該当し、もしくは前項各号のいずれかに該当する行為をし、又は第１項の規定に基づく表明・確約に関して虚偽の申告をしたことが判明した場合には、自己の責に帰すべき事由の有無を問わず、相手方に対して何らの催告をすることなく本契約を解除することができる。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ４　本条に基づく本契約の解除は、解除した当事者から解除された当事者に対する損害賠償の請求を妨げない。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ５　本条に基づく本契約の解除がされた場合、これにより損害が発生した場合であっても、解除された当事者は、解除した当事者に対して損害賠償を請求することはできない。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第２２条（解約）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      １　申込者又は弊社は、相手方が次の各号のいずれかの事由に該当した場合、あらかじめ相手方に通知又は催告をすることなく、本契約を解除することができる。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （１）本規約（特約がある場合は、その場合も含む）の各条項に違反した場合
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （２）手段の如何を問わず、本サービスの運営を妨害した場合
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （３）支払期日を経過し、相当期間を定めてなした催告後も、報酬等が支払われない場合
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （４）手形又は小切手が、不渡りとなった場合
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （５）租税公課の滞納処分を受けた場合
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （６）監督官庁より営業許可の取消、停止等の処分を受けた場合
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （７）差押、仮差押、仮処分、強制執行、破産、民事再生、会社更生、特別清算の申立てがなされた場合、又は申込者自らが破産、民事再生、会社更生、特別清算の申立てを行った場合
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （８）解散、会社分割、事業の全部又は重要な一部の譲渡を行う場合
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （９）合併により消滅する場合
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7, pl: 2 }}>
                      （１０）その他本規約の各条項の履行が困難であると客観的に認められる相当の事情が生じたとき
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ２　申込者又は弊社が前項各号のいずれかに該当した場合、相手方に対して負っている債務について当然に期限の利益を失うものとする。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ３　前各項により、解除された当事者に損害が発生した場合でも、その相手方は一切の責任を負わない。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第２３条（期間）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      １　本契約の有効期間は、弊社所定の申込書に記載の利用開始日から１年間とする。ただし、申込者弊社いずれからも期間満了１ヵ月前までに書面による解約の申し出がない場合は、更に１年間本契約を更新するものとし、以後も同様とする。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ２　前項の定めにかかわらず申込者は、弊社所定の様式で届け出ることにより、本契約を解除することができる。
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      ３　申込者は、本契約期間中に発生した債務については、本契約終了後も弊社に対する支払を免れることはできない。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ４　本契約終了後においても、第６条第７項、第７条５項、第１２条から第１４条、第１７条、第１８条、第２０条から第２２条、第２４条から第２５条、前項及び本項はなおも効力を有する。また、本契約終了時点において、弊社が申込者に紹介し既に申込者における選考が開始している候補者に関しては、本契約の各条項が適用されるものとする。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第２４条（権利義務譲渡の禁止）
                  </Typography>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1, lineHeight: 1.7 }}>
                      １　申込者は、弊社の書面による事前の承諾なく、本契約上の地位又は本規約に基づく権利もしくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできない。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ２　弊社は本契約にかかる事業を他社に譲渡した場合、当該事業譲渡に伴い本契約上の地位、本契約に基づく権利及び義務並びに申込者の登録情報その他の顧客情報を当該事業譲渡の譲受人に譲渡することができるものとし、申込者は、かかる譲渡につき本項においてあらかじめ同意したものとする。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとする。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第２５条（紛争解決）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ mt: 1, lineHeight: 1.7 }}>
                    本規約に定めのない事項又は本規約の解釈に関して疑義のある事項については、申込者及び弊社は誠意をもって協議のうえ解決する。万一協議が調わない場合は、訴額に応じ、被告の本店所在地を管轄する地方裁判所又は簡易裁判所を第一審の専属的合意管轄裁判所とする。
                  </Typography>
                }
              />
            </ListItem>
          </List>

          <Divider sx={{ mb: 4 }} />

          <Box sx={{ mb: 4, textAlign: 'center' }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              ２０２５年9月9日制定
            </Typography>
          </Box>

          <Divider sx={{ mb: 4 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" component="div" sx={{ mb: 2, fontWeight: 'bold' }}>
              お問い合わせ先
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              電話番号：06-7176-5480
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              FAX番号：06-7635-8254
            </Typography>
            <Typography variant="body1">
              E-mail：info@gakufudo-career.jp
            </Typography>
          </Box>

          <Divider sx={{ mb: 3 }} />

          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="body2" color="text.secondary">
              以上
            </Typography>
          </Box>
        </Paper>

        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Typography 
            variant="body2" 
            color="white" 
            sx={{ opacity: 0.8 }}
          >
            © {new Date().getFullYear()} 株式会社Gerbera. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default TermsCompanyPage;
